import { updateChangeStatus } from "./chat";
import { useSelector, useDispatch } from "react-redux";
import { setMessage } from "../../../store/operator/actions";
import { isArray, isObject } from "../../../Libs/CustomMethods/customMethods";

const useMoreConversation = () => {
  const { messageOperator } = useSelector((state) => state.Operator);
  const dispatch = useDispatch();

  return {
    handleInactiveBySystem: (data) => {
      let chatId = data?.conversationId;
      if (chatId) {
        updateChangeStatus(
          chatId,
          "inactive",
          messageOperator,
          dispatch,
          setMessage
        );
      }
    },

    handleEndPreChat: (data) => {
      let chatId = data?.conversationId;
      if (chatId) {
        updateChangeStatus(
          chatId,
          "queue",
          messageOperator,
          dispatch,
          setMessage
        );
      }
    },

    handleEndPosChat: (data) => {
      let chatId = data?.conversationId;
      if (chatId) {
        updateChangeStatus(
          chatId,
          "closed",
          messageOperator,
          dispatch,
          setMessage
        );
      }
    },

    // TODO: improve this method
    handleJoinedManager: (data, getChat, updateChat) => {
      if (isObject(data)) {
        let chats = messageOperator?.chats;
        let chat = getChat(data?.conversationId);
        let users = null;
        let user = data?.user;

        if (chats && chat?.index >= 0) {
          users = chats.data[chat.index]?.users;

          if (isArray(users)) {
            users.push(user);
            updateChat(chats);
          }
        }
      }
    },
  };
};

export default useMoreConversation;
